import React, { createContext, useContext, useState } from "react";

import { releaseOrdersTabs, ReleaseOrdersTabValuesType } from "../utils/release-orders-Tabs";
import { orderModes, OrderModesTypes } from "../../utils/modes";
import { useFetchTableData } from "hooks/useFetchTableData";
import { IOrder, ISample } from "../../interface";
import { IData } from "hooks/useGetData";

export const OrderReleaseOrdersContext = createContext<any>(null);

const mode: OrderModesTypes = orderModes.releaseOrders;
export const OrderReleaseOrdersContextProvider = ({ children }) => {
    const [selectedOrders, setSelectedOrders] = useState<IOrder[]>([]);
    const [selectedSamples, setSelectedSamples] = useState<ISample[]>([]);

    const [selectedTab, setSelectedTab] = useState<ReleaseOrdersTabValuesType>(releaseOrdersTabs.samples);

    const [refreshOrdersData, setRefreshOrdersData] = useState<Function | undefined>(undefined);

    const sampleObj = useFetchTableData<ISample>({
        url: selectedOrders.length > 0 ? `/samples` : undefined,
        triggerValues: [selectedOrders[0]?.id],
        additionalParams: `&orderId=${selectedOrders[0]?.id}`,
        onUnmount: () => setSelectedSamples([]),
        pendingDependencies: [selectedOrders[0]?.id],
    });

    return (
        <OrderReleaseOrdersContext.Provider
            value={{
                selectedOrders,
                setSelectedOrders,
                selectedSamples,
                setSelectedSamples,
                refreshOrdersData,
                setRefreshOrdersData,
                selectedTab,
                setSelectedTab,
                mode,
                sampleObj,
            }}
        >
            {children}
        </OrderReleaseOrdersContext.Provider>
    );
};

export const useOrderReleaseOrders = (): IUseOrderReleaseOrders => {
    const {
        selectedOrders,
        setSelectedOrders,
        selectedSamples,
        setSelectedSamples,
        refreshOrdersData,
        setRefreshOrdersData,
        selectedTab,
        setSelectedTab,
        mode,
        sampleObj,
    } = useContext(OrderReleaseOrdersContext);

    return {
        selectedOrders,
        setSelectedOrders,
        selectedSamples,
        setSelectedSamples,
        refreshOrdersData,
        setRefreshOrdersData,
        selectedTab,
        setSelectedTab,
        mode,
        sampleObj,
    };
};

interface IUseOrderReleaseOrders {
    selectedOrders: IOrder[];
    setSelectedOrders: (arg: IOrder[]) => void;
    selectedSamples: ISample[];
    setSelectedSamples: (arg: ISample[]) => void;
    refreshOrdersData: Function;
    setRefreshOrdersData: Function;
    selectedTab: ReleaseOrdersTabValuesType;
    setSelectedTab: (arg: ReleaseOrdersTabValuesType) => void;
    mode: OrderModesTypes;
    sampleObj: {
        data: IData<ISample>;
        setData: React.Dispatch<React.SetStateAction<IData<ISample>>>;
        refreshData: Function;
        handleReload: (params: any, refresh: any) => void;
        isPending: boolean;
    };
}
